import { useRef, useEffect } from 'react';
import { AgentChatClient } from '../services/AgentChatClient';

export const useAgentChatClient = () => {
  const clientRef = useRef<AgentChatClient>(new AgentChatClient());

  useEffect(() => {
    clientRef.current.connect().catch(console.error);

    return () => {
      clientRef.current.disconnect();
    };
  }, []);

  return clientRef.current;
};